<template>
    <v-footer app color="grey lighten-1">
        <v-spacer></v-spacer>
        <span class="overline">&copy; {{ new Date().getFullYear() }} SECRETARÍA GENERAL - Sistema de control de oficios V.{{version}}</span>
    </v-footer>
</template>

<script>

import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters([
            "version"
        ]),
    },
    data: () => ({
        loading: false,
    })
}
</script>